export type AuthType = 'Combined' | 'OpenId' | 'Password' | 'Password2FA' | 'Saml' | 'WsFederation';

export enum AuthTypeId {
  Password = 0,
  Password2FA = 1,
  OpenId = 2,
  WsFederation = 3,
  Saml = 4,
  Combined = 5,
}

export const AUTH_TYPE_MAP: Record<number, AuthType> = {
  [AuthTypeId.Password]: 'Password',
  [AuthTypeId.Password2FA]: 'Password2FA',
  [AuthTypeId.OpenId]: 'OpenId',
  [AuthTypeId.WsFederation]: 'WsFederation',
  [AuthTypeId.Saml]: 'Saml',
  [AuthTypeId.Combined]: 'Combined',
};
